<template>
  <v-card>
    <v-toolbar  dark color="indigo lighten-1">
      <v-btn icon dark @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ accion == 'edit' ? 'Editar' : 'Registrar' }} Toca</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="resetValidation()">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card  class="py-0 mb-0 pt-0"  elevation="7">
        <v-col cols="12" class="py-2 mb-0 pt-0">
          <div class="mx-4 py-3" style="background-color: #F5F5F5">
            <v-card class="mx-4">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-title class="primary white--text">
                  Toca: {{ num_toca }}<br>
                  Tipo de Juicio: {{ tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }}
                </v-card-title>
                <v-container class="mt-9">
                  <!-- only for admin-->
                  <v-autocomplete
                    outlined
                    label="Ponencia"
                    item-text="nombre"
                    item-value="id"
                    persistent-hint
                    :items = "getAllPonencias"
                    v-model="ponencia_selected"
                    required
                    :rules="[rules.requiredSelect]"
                    v-if="roleUser == 'superadmin' "
                  />
                  <!-- end only for admin-->
                  <v-row>
                    <v-col
                      class="mt-n2"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        outlined
                        v-model="expediente"
                        label="Expediente / Carpeta Administrativa"
                        required
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      class="mt-n2"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        outlined
                        v-model="oficio"
                        maxlength="50"
                        :counter="50"
                        label="Num. Oficio"
                        required
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      class="mt-n4"
                    >
                      <v-autocomplete
                        outlined
                        label="Distrito"
                        item-text="nombre"
                        item-value="id"
                        persistent-hint
                        :items = "getDistritos"
                        v-model="distrito_id"
                        required
                        :rules="[rules.requiredSelect]"
                        :disabled="accion == 'edit'"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="mt-n4"
                    >
                      <v-autocomplete
                        :disabled="!distrito_id || accion == 'edit'"
                        outlined
                        label="Juzgado"
                        item-text="nombre"
                        item-value="id"
                        persistent-hint
                        :items = "getAllJuzgados"
                        v-model="juzgado_id"
                        required
                        :rules="[rules.requiredSelect]"
                      >
                        <template v-slot:item="slotProps">
                          <v-icon class="ml-n3">mdi-arrow-right-thick</v-icon>
                          {{ slotProps.item.nombre }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="mt-n4">
                      <div style="background-color:white">
                        <v-textarea
                          outlined
                          name="apelante"
                          label="Apelante"
                          v-model="apelante"
                          required
                          :rules="[rules.required]"
                        ></v-textarea>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-n4">
                      <v-textarea
                        outlined
                        name="inculpado"
                        label="Inculpado"
                        v-model="inculpado"
                        required
                        :rules="[rules.required]"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" class="mt-n4">
                      <!-- materia_apelacion -->
                      <v-autocomplete
                        label="Tipo de Oficio"
                        item-text="nombre"
                        item-value="id"
                        persistent-hint
                        :items = "getAllTiposApelacion"
                        v-model="materia_apelacion"
                        outlined
                        required
                        :rules="[rules.requiredSelect]"
                      />
                    </v-col>
                    <v-col cols="12" md="4" class="mt-n4">
                      <v-menu
                        v-model="menu_fecha_apelacion"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fecha_apelacion"
                            label="Fecha del Auto Apelado"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            required
                            :rules="[rules.required]"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fecha_apelacion"
                          @input="menu_fecha_apelacion = false"
                          locale="es-mx"
                          :max="today"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4" class="mt-n4">
                      <v-menu
                        v-model="menu_fecha_recepcion"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fecha_recepcion"
                            label="Recepción"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            required
                            :rules="[rules.required]"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fecha_recepcion"
                          @input="menu_fecha_recepcion = false"
                          locale="es-mx"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6" class="mt-n4">
                      <v-autocomplete
                        return-object
                        label="Delito"
                        item-text="nombre"
                        item-value="id"
                        :items = "getAllDelitos"
                        v-model="select_delito"
                        persistent-hint
                        outlined
                        required
                        :rules="[rules.requiredSelect]"
                        @change="addDelito(select_delito)"
                        :loading='loadingDelitos'
                      />
                      <v-btn
                        outlined
                        block
                        color="teal"
                        :disabled="loadingDelitos"
                        @click="refreshDelitos(), loadingDelitos = true"
                        class="mt-n6 mb-1 white--text"
                      >
                        ACTUALIZAR LISTA DE DELITOS
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-n4" v-if="array_delitos.length">
                      <h4 class="red--text">DELITOS SELECCIONADOS:</h4>
                      <ul v-for="(delito, i) in array_delitos" :key="'delitoId_' + i">
                        <li class="ml-n3">
                          <h5>
                            {{ delito.nombre }}
                            <v-btn
                              small
                              icon
                              color="pink"
                              @click="removeItem(delito)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </h5>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="tipo_juicio=='JO'" cols="12" class="mt-2">
                      <v-text-field
                        v-if="this.accion == 'add'"
                        outlined
                        v-model="hash"
                        label="HASH"
                        placeholder="Ingrese HASH"
                        required
                        :rules="[rules.required]"
                        @keyup="alert_apelacion= false"
                      ></v-text-field>
                      <v-btn
                          v-if="accion == 'add'"
                          block
                          dark
                          color="blue darken-3"
                          :loading="loadingHash"
                          :disabled="!hash"
                          @click="getApelacion()"
                          class="mb-3 mt-n5"
                        >
                          Buscar
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                      <!-- NO RESULTADO -->
                        <v-col  cols="12" class="mt-2">
                          <v-alert
                            v-if="alert_apelacion"
                            v-model="alert_apelacion"
                            dense
                            dark
                            dismissible
                            type="error"
                          >
                            No se encontró Apelación para el HASH.
                          </v-alert>
                        </v-col>
                        <v-col  cols="12" class="mt-2">
                          <v-alert
                            v-if="alert_resultados"
                            v-model="alert_resultados"
                            dense
                            dark
                            outlined
                            type="success"
                          >
                            <b>Resultados de la búsqueda para el HASH.</b>
                          </v-alert>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" v-if="e_apelacion.id" class="mb-n1">
                          <h3 v-if="e_apelacion.numero_carpeta">NUM. DE CARPETA ADMINISTRATIVA:<span style="color: #225882"> {{e_apelacion.numero_carpeta}}</span></h3>
                          <v-divider></v-divider>
                          <h3 v-if="e_apelacion.num_oficio">NUM. DE OFICIO:<span style="color: #225882"> {{ e_apelacion.num_oficio }} </span></h3>
                          <v-divider></v-divider>
                          <div v-if="e_apelacion.nombre_creador">
                            <span class="font-weight-small black--text mr-3"  style="color: #225882">CREADOR:</span><b>{{ e_apelacion.nombre_creador }}</b><br>
                          </div>
                          <v-divider></v-divider>
                          <span v-if="e_apelacion.nombre_juzgado" class="font-weight-small black--text mr-3">JUZGADO:</span><b>{{ e_apelacion.nombre_juzgado }}</b><br>
                          <v-divider></v-divider>
                        </v-col>

                        <v-col cols="12" sm="6" dark>
                          <span class="mr-3" v-if="e_apelacion.hash"> <b>HASH:</b> <b style="color:#D81B60;font-size:22px">{{ e_apelacion.hash }} </b></span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" v-if="e_apelacion.id">
                            <v-divider class="mt-2"></v-divider>
                            <div v-for="(doc, i) in e_apelacion.documento_carpeta" :key="'doc_'+ i">
                              <h3 class=" mt-2">
                                <span v-if="doc.tipo == 1" style="color: darkslategrey">
                                  APELACIÓN ELECTRÓNICA:
                                </span>
                                <span v-if="doc.tipo == 2" style="color: darkslategrey">
                                  CARPETA ADMINISTRATIVA:
                                </span>
                                <span v-if="doc.tipo == 3" style="color: darkslategrey">
                                  CERTIFICACION DE CARPETA ADTVA.:
                                </span>
                                <v-btn
                                  x-small
                                  color="indigo"
                                  dark
                                  class="ml-2"
                                  @click="getFile(doc)"
                                >
                                  <v-icon left x-small>
                                    mdi-eye
                                  </v-icon>
                                  Ver documento
                                </v-btn>
                              </h3>
                              <v-divider class="mt-2"></v-divider>
                            </div>
                        </v-col>
                        <v-col cols="12" md="11" class="mt-2 mb-3" v-if="e_apelacion.videos">
                          <h3 class="indigo--text">VIDEO AUDIENCIAS:</h3>
                          <h3 v-if="!e_apelacion.videos.length">
                            <li>La apelación electrónica no contiene videos.</li>
                          </h3>
                          <ul v-for="(video, i) in e_apelacion.videos" :key="'videoId_' + i">
                            <li class="ml-n3">
                              <h3>
                                {{ video.file_name }}

                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-btn
                                        small
                                        color="teal"
                                        icon
                                        dark
                                        class="ml-5"
                                        @click="getVideo(video)"
                                      >
                                        <v-icon>
                                          mdi-video
                                        </v-icon>
                                      </v-btn>&nbsp;
                                    </span>
                                  </template>
                                    <span>Ver Video Audiencia</span>
                                </v-tooltip>
                              </h3>
                            </li>
                            <v-divider></v-divider>
                          </ul>
                        </v-col>
                      </v-row>
                      <!--  dialog loading -->
                      <v-dialog
                        v-model="progress"
                        persistent
                        width="300"
                      >
                        <v-card
                          color="#0A4A79"
                          dark
                        >
                          <v-card-text>
                            Cargando Archivo
                            <v-progress-linear
                              indeterminate
                              color="white"
                              class="mb-0"
                            ></v-progress-linear>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                  </v-row>
                  <!-- <v-card flat class="mt-6">
                    <v-toolbar
                      color="#E0E0E0"
                      dense
                      flat
                    >
                      <h3 style="color: #0D47A1">Seleccione Tipo de Registro</h3>
                    </v-toolbar>
                    <v-card-text >
                      <v-row>
                        <v-col cols="12" md="5" class="mt-n3">
                          <v-radio-group v-model="tipo_registro"
                            required
                            :rules="[rules.required]"
                          >
                            <v-radio
                              label="Para Turnar"
                              id="cero"
                              value="20"
                            ></v-radio>

                            <v-radio
                              label="Sin Turnar"
                              id="three"
                              value="10"
                            ></v-radio>

                            <v-radio
                              label="Para Registrar Amparo"
                              id="five"
                              value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-divider vertical></v-divider>

                        <v-col cols="12" md="6" class="mt-n3">
                          <v-menu
                            v-model="menu_fecha_recepcion"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fecha_recepcion"
                                label="Recepción"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                required
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="fecha_recepcion"
                              @input="menu_fecha_recepcion = false"
                              locale="es-mx"
                            >
                            </v-date-picker>
                          </v-menu>
                          <v-menu
                            v-model="menu_fecha_citacion"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            v-if="tipo_registro == '20' "
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fecha_citacion"
                                label="Citación"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                v-if="tipo_registro == '20' "
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="fecha_citacion"
                              @input="menu_fecha_citacion = false"
                              v-if="tipo_registro == '20' "
                              locale="es-mx"
                            >
                            </v-date-picker>
                          </v-menu>
                          <v-menu
                            v-model="menu_fecha_turno"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            v-if="tipo_registro == '20' "
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fecha_turno"
                                label="Turno"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                v-if="tipo_registro == '20' "
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="fecha_turno"
                              @input="menu_fecha_turno = false"
                              v-if="tipo_registro == '20' "
                              locale="es-mx"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="mt-n4">
                          <v-autocomplete
                            outlined
                            label="Ponencia"
                            item-text="nombre"
                            persistent-hint
                            :items = "getAllPonencias"
                            item-value="id"
                            :item-text=" item => item.nombre + ' (' + item.magistrado + ')' "
                            v-model="ponencia_selected"
                            required
                            :rules="[rules.requiredSelect]"
                            v-if="tipo_registro=='1'"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card> -->
                  <v-btn
                    block
                    color="teal"
                    :loading="loading"
                    :disabled="!valid"
                    @click="validate"
                    class="mb-6 white--text"
                  >
                    GUARDAR
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-divider></v-divider>
                </v-container>
              </v-form>
            </v-card>
          </div>
        </v-col>
    </v-card>
  </v-card>
</template>

<script>
  import {mapGetters, mapMutations} from "vuex";
  import BaseSelect from "@/components/BaseSelect.vue";
  import Autocomplete from "@/components/Autocomplete";

  export default {
    props: {
      sala_id: {
        type: Number,
        required: true
      },
      toca: {
        type: undefined,
        required: true
      },
      num_toca: {
        type: String,
        required: false
      },
      tipo_juicio: {
        type: String,
        required: true
      },
      accion: {
        type: String,
        required: true
      }
    },
    components: { BaseSelect, Autocomplete },
    data: () => ({
      loadingData: true,
      checkedToca: false,
      disabledJuzgado: true,
      disabled: true,
      dialog:false,
      menu_fecha_recepcion: false,
      menu_fecha_citacion: false,
      menu_fecha_turno: false,
      menu_fecha_apelacion: false,
      municipio_id:'', //municipio_id =>para filtrar los juzgados por municipio_id
      tipo_registro: 10,  //para comportamiento de mostrar ponencias y sirve para registrar un amparo
      ponencia_selected:'',
      valid: false,
      loading: false,
      numero: "",
      anio: "",
      expediente: "",
      complemento:"",
      oficio: "",
      juzgado_id: "",
      distrito_id:"",
      // partido_id:"",
      apelante: "",
      inculpado: "",
      materia_apelacion: "",
      array_delitos: [],
      select_delito: "",
      loadingDelitos: false,
      fecha_apelacion: "",
      fecha_recepcion: "",
      fecha_citacion: "",
      fecha_turno: "",
      loadingHash:false,
      // radio_apelacion: "",
      hash: "",
      alert_apelacion: false,
      alert_resultados: false,
      e_apelacion: [],
      data_file: "",
      progress: false,
      today: new Date().toJSON().slice(0,10),
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
      this.$store.dispatch("GET_ALL_MUNICIPIOS", { url: "municipios" });
      this.$store.dispatch("GET_DISTRITOS", { url: "/distritos" });
      this.$store.dispatch("GET_PARTIDOS", { url: "/partidos" });
      this.$store.dispatch("GET_ALL_TIPOS_APELACION", { url: "/tipo-apelaciones" });
      this.$store.dispatch("GET_ALL_DELITOS", { url: "/listDelitos" });
      if (this.roleUser == "superadmin"){
        this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      }
    },
    mounted(){
      if (this.toca) {
        this.expediente = this.toca.expediente
        this.oficio= this.toca.last_apelacion.oficio
        this.juzgado_id= this.toca.last_apelacion.juzgado_data.id
        this.municipio_id= this.toca.last_apelacion.juzgado_data.municipio_id
        this.apelante= this.toca.last_apelacion.apelante
        this.inculpado= this.toca.last_apelacion.inculpado
        this.materia_apelacion = this.toca.last_apelacion.tipo_apelacion_id
        this.select_delito = {};
        this.toca.last_apelacion.delitos.forEach(delito => this.array_delitos.push(delito));
        this.fecha_recepcion = this.toca.last_apelacion.fecha_recepcion.slice(0, 10)
        this.fecha_apelacion = this.toca.last_apelacion.fecha_apelacion
        this.distrito_id = this.toca.last_apelacion.juzgado_data.distrito_id
        this.hash = this.toca.last_apelacion.hash
        if (this.hash) this.getApelacion()
      }
    },
    destroyed() {
      // console.log("Componente eliminado"); se destruye con el v-if del papa
    },
    watch: {
      distrito_id() {
        if (this.distrito_id) {
          this.getJuzgadosDistrito();
          this.disabledJuzgado = false
        }
      },
      // partido_id() {
      //   if (this.partido_id) {
      //     this.getJuzgadosPartido();
      //     this.disabledJuzgado = false
      //   }
      // },
      tipo_registro(){
        switch (this.tipo_registro) {
          case "20": //para turnar =>Mostrar las 3 fechas
            this.fecha_citacion = ""
            break;
          case "10":
            this.fecha_citacion = ''
            this.fecha_turno=''
            break;
          case "1":
            this.fecha_citacion = ''
            this.fecha_turno=''
            //solamente el user de Secretario de Acuerdos puede ejecutar las ponencias por su Sala_id
            if (this.roleUser != "superadmin"){ //cargar las ponencias cuando sea apara amparo y cuando sea diferente a admin
              //cuando ingresamos como admin ya cargamos las ponencias en el created
              // this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
              // this.$store.dispatch("GET_PONENCIAS_BY_SALA");
            }
            break;
        }
      },
    },
    computed: {
      ...mapGetters([
          "currentUser",
          "roleUser",
          "getAllMunicipios",
          "getAllJuzgados",
          "getAllTiposApelacion",
          "getAllPonencias",
          "getAllDelitos",
          "getDistritos",
          "getPartidos"
        ]),
    },
    methods:{
      validate() {
        if (typeof(this.select_delito)=='object' && !this.array_delitos.length) {
          this.select_delito = ''
          return false
        }
        if (this.$refs.form.validate()) {
          if (this.tipo_juicio == 'JO' && this.e_apelacion.length==0) {
            this.$swal({
              title: "Error",
              text: "Favor de revisar el 'HASH' de la apelacion electrónica.",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
            return false;
          }
          this.complemento = this.num_toca.split('-').splice(1).join('-');
          var toca_registrar = this.num_toca.split('-')[0];
          var tocacompleto = toca_registrar.replace('/','');
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          this.loading = true;
          this.save();
        }
      },
      save() {
        this.store_action = 'CREATE_TOCA'
        this.url = '/apelacion'
        this.swalText = 'Toca registrada correctamente.'
        if (this.accion == 'edit') {
          this.store_action = 'UPDATE_APELACION'
          this.url = '/apelacion/' + this.toca.last_apelacion.id + '/editar'
          this.swalText = 'Toca editada correctamente.'
        }
        var toca = {
          numero: this.numero,
          anio: this.anio,
          derivado:this.complemento,
          sala_id: this.sala_id,
          expediente: this.expediente,
          hash: this.hash,
          tipo_juicio : this.tipo_juicio,
          oficio: this.oficio,
          juzgado_id: this.juzgado_id,
          apelante: this.apelante,
          inculpado: this.inculpado,
          tipo_apelacion_id : this.materia_apelacion,
          delitos: this.array_delitos,
          fecha_recepcion: this.fecha_recepcion,
          fecha_apelacion: this.fecha_apelacion,
          fecha_citacion: this.fecha_citacion,
          fecha_turno: this.fecha_turno,
          status: this.tipo_registro,
          ponencia_id: this.ponencia_selected
        }
        this.$store.dispatch(this.store_action, { url: this.url, data:toca }).then(response => {
            this.loading = false;
            if (response.data.status == "ok") {
              this.$swal({
                title: "Éxito!!!",
                text: this.swalText,
                icon: "success",
                confirmButtonText: "Aceptar"
              });
            }
            this.$emit('reloadTocas');
            this.resetValidation()
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message || error.response.data,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
      resetValidation () {
        this.$emit('closeModal');
        this.dialog = false
        this.$refs.form.resetValidation()
        // this.radio_apelacion=""
        this.numero=""
        this.anio=""
        this.complemento=""
        this.expediente=""
        this.oficio=""
        this.juzgado_id=""
        this.apelante=""
        this.inculpado=""
        this.materia_apelacion=""
        this.select_delito=""
        this.array_delitos=""
        this.fecha_recepcion=""
        this.fecha_citacion=""
        this.fecha_turno= ""
        this.has_reconvencion=""
        this.municipio_id=""
        this.tipo_registro=""
      },
      // getJuzgadosByMunicipio() {
      //   this.$store.dispatch("GET_ALL_JUZGADOS", {
      //       url: '/juzgadosMunicipio',
      //       params: { municipio_id: this.municipio_id }
      //     });
      // },
      getJuzgadosDistrito() {
        this.$store.dispatch("GET_ALL_JUZGADOS", {
            url: '/juzgados-distrito',
            params: { distrito_id: this.distrito_id }
          });
      },
      // getJuzgadosPartido() {
      //   this.$store.dispatch("GET_ALL_JUZGADOS", {
      //       url: '/juzgados-partido',
      //       params: { partido_id: this.partido_id }
      //     });
      // },
      addDelito(item){
        if (item.id) {
          item.delito_id = item.id
          // delete(item.id)
        }
        this.resultado = this.array_delitos.find( delito => delito.delito_id === item.delito_id );
        if (!this.resultado) {
          this.array_delitos.push(item);
           if (this.accion != 'add') {
            this.updateDelito(item, 'add_delito');
           }
        }
        this.select_delito = {};
      },
      removeItem(item){
        this.array_delitos.splice(this.array_delitos.indexOf(item), 1);
        if (this.accion != 'add') {
          this.updateDelito(item, 'delete_delito');
        }
      },
      updateDelito(item, action){
        if (action=='add_delito') {
          this.store_action = 'SAVE_DELITO'
          this.url = '/apelacion_delito/' + this.toca.last_apelacion.id
          this.swalText='Delito agregado correctamente.'
        }
        if (action=='delete_delito')  {
          this.store_action = 'DELETE_DELITO'
          this.url = '/apelacion_delito/' + item.id
          this.swalText='Delito eliminado correctamente.'
        }
        this.$store.dispatch(this.store_action, {
            url: this.url,
            data: {
              delito_id: item.delito_id,
              nombre: item.nombre,
              apelacion_id: this.toca.last_apelacion.id
            }
          }).then(response => {
            // console.log(response)
          if (response.data.status == "ok") {
            this.$swal({
              title: "Éxito!!!",
              text: this.swalText,
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            // this.$emit('reloadTocas');
          }
        }).catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
      getApelacion() {
        this.e_apelacion = []
        this.loadingHash = true;
        this.loading = true
        this.$store.dispatch("CREATE_TOCA", { url: "/apelacion/show-apelacion",
         data:{ hash: this.hash, sala_id: this.sala_id} })
         .then(response => {
            this.loadingHash = false;
            this.loading = false
            if (response.data.status == "ok" && response.data.data.apelacion_electronica.length) {
              this.alert_apelacion = false
              this.e_apelacion = response.data.data.apelacion_electronica[0]
              this.alert_resultados = true
            }
            else {
              this.alert_apelacion = true
              this.alert_resultados = false
            }
          })
          .catch(error => {
            this.loadingHash = false;
            this.$swal({
              title: "Error",
              text: "Ocurrio un error",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
      getFile(item){
        this.data_file = { url_documento: item.url }
        this.progress = true
        this.$store.dispatch("CREATE_TOCA", { url: '/apelacion/show-file',  data: this.data_file })
        .then((response) => {
        // console.log(response.data);
            const link = document.createElement('a');
            // var showFile = response.data.data.presignedUrl // Pruebas local
            var showFile = JSON.parse(response.data.data.presignedUrl.body); // producción
            link.href = showFile;
            console.log(link);
            // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            // const link = document.createElement('a');
            // link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
            // this.indexLoader = -1
            // this.indexContestacion = -1
          }).catch(err => {
            this.progress = false
            console.log(err);
          });
      },
      getVideo (item) {
        this.$store.dispatch("CREATE_TOCA",  { url: '/apelacion/show-video', data:{ url_video_audiencia: item.url_video_audiencia } } )
        .then(response => {
           console.log(response.data);
          const link = document.createElement('a');
          var showVideo = JSON.parse(response.data.data.presignedUrl.body);
          link.href = showVideo;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
        }).catch(error => {
          console.log(error);
        });
      },
      clearApelacion(){
       this.hash=''
       this.e_apelacion = []
       this.alert_resultados = false
       this.alert_apelacion = false
      },
      refreshDelitos(){
        this.$store.dispatch("GET_ALL_DELITOS", { url: "/listDelitos" }).then(response => {
          this.loadingDelitos = false;
        })
      }
    }
  };
</script>